<template>
  <form class="supporterForm grid-12" onsubmit="return false" @submit="send">
    <h3>Dados Pessoais</h3>
    <div class="row wrap justify-around column-s">
      <div class="column grid-2 grid-12-s">
        <label>CPF</label>
        <input type="text" v-model="form.cpf" v-mask="'###.###.###-##'" required />
      </div>

      <div class="column grid-2 grid-12-s">
        <label>RG <i>(rg, emissor, estado)</i></label>
        <input v-model="form.rg" placeholder="Rg, Emissor, Estado" required />
      </div>

      <div class="column grid-2 grid-12-s">
        <label>Nome</label>
        <input v-model="form.nome" placeholder="Nome" required />
      </div>

      <div class="column grid-2 grid-12-s">
        <label>Data Nascimento</label>
        <input v-model="form.dt_nascimento" v-mask="'##/##/####'" placeholder="Data Nascimento" />
      </div>

      <div class="column grid-2 grid-12-s">
        <label>Sexo</label>
        <select type="text" v-model="form.sexo" required>
          <option value>Selecione</option>
          <option value="M">Masculino</option>
          <option value="F">Feminino</option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>PcD (<i>possui deficiência</i>)</label>
        <select type="text" v-model="form.pcd" required>
          <option value>Selecione</option>
          <option value="N">Não</option>
          <option value="S">Sim</option>
        </select>
      </div>
    </div>

    <h3>Contatos</h3>
    <div class="row wrap justify-around column-s">
      <div class="row grid-12 wrap column-s justify-around">
        <div class="column grid-3 grid-12-s">
          <label>E-mail</label>
          <input type="text" v-model="form.email" required />
        </div>

        <div class="column grid-2 grid-12-s">
          <label>Fone</label>
          <input v-model="form.fone" placeholder="Fone" v-mask="'(##) ####-####'" />
        </div>

        <div class="column grid-2 grid-12-s">
          <label>Celular</label>
          <input v-model="form.celular" placeholder="Celular" v-mask="'(##) #####-####'" required />
        </div>

        <div class="column grid-2 grid-12-s">
          <label>CEP</label>
          <input v-model="form.cep" placeholder="CEP" v-mask="'##.###-###'" @input="cep" required />
        </div>

        <div class="column grid-2 grid-12-s">
          <label>Cidade</label>
          <input v-model="form.cidade" placeholder="Cidade" />
        </div>
      </div>
    </div>
    <div class="row grid-12 wrap column-s justify-around">
      <div class="column grid-3 grid-12-s">
        <label>Logradouro</label>
        <input v-model="form.logradouro" placeholder="Logradouro" required />
      </div>

      <div class="column grid-2 grid-12-s">
        <label>Número</label>
        <input v-model="form.numero" placeholder="Número" />
      </div>

      <div class="column grid-2 grid-12-s">
        <label>Bairro</label>
        <input v-model="form.bairro" placeholder="Bairro" />
      </div>

      <div class="column grid-2 grid-12-s">
        <label>UF</label>
        <input v-model="form.estado" placeholder="Número" />
      </div>

      <div class="column grid-2 grid-12-s">
        <label>Complemento</label>
        <input v-model="form.complemento" placeholder="Complemento" />
      </div>
    </div>

    <div class="row column-s">
      <div class="grid-6 grid-12-s">
        <h3>Dados Pessoa Jurídica</h3>
        <div class="row grid-12 wrap column-s justify-around">
          <div class="column grid-6 grid-12-s">
            <label>CNPJ</label>
            <input v-model="form.cnpj" placeholder="CNPJ" v-mask="'##.###.###/####-##'" />
          </div>
          <div class="column grid-6 grid-12-s">
            <label>Razão Social</label>
            <input v-model="form.razao_social" placeholder="Razão Social" />
          </div>
        </div>
      </div>
      <div class="grid-6 grid-12-s align-center column">
        <h3>Credenciais</h3>
        <div class="grid-6 justify-center">
          <br />
          <label>Usuário NS Community</label>
          <input v-model="form.ns_community" placeholder="Usuário NS Community" />
        </div>
      </div>
    </div>

    <h3>Dados Bancários</h3>

    <div class="row grid-12 wrap column-s justify-around">
      <div class="grid-3-g grid-5-m grid-12-s label column">
        <label>Banco</label>
        <select type="text" class="input" v-model="form.id_banco" required>
          <option value>Selecione</option>
          <option v-for="(b, i) of banks" :value="b.id" :key="'bank' + i">
            {{ b.nome }} - ({{ b.codigo }})
          </option>
        </select>
      </div>
      <div class="grid-1-g grid-3-m grid-12-s label column">
        <label>Agência</label>
        <input type="text" class="input" v-model="form.agencia_banco" required />
      </div>
      <div class="grid-1-g grid-2-m grid-12-s label column">
        <label>DV Agência</label>
        <input type="text" class="input" v-model="form.dv_agencia_banco"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          min="0" max="9" maxlength="1" step="1" />
      </div>
      <div class="grid-2-g grid-3-m grid-12-s label column">
        <label>Conta</label>
        <input type="text" class="input" v-model="form.conta_banco" required />
      </div>
      <div class="grid-1-g grid-2-m grid-12-s label column">
        <label>DV Conta</label>
        <input type="number" class="input" v-model="form.dv_conta_banco" maxlength="1" required />
      </div>
      <div class="grid-1-g grid-3-m grid-12-s label column">
        <label>Tipo Conta</label>
        <select type="text" class="input" v-model="form.tipo_conta" required>
          <option value>Selecione</option>
          <option value="corrente">Conta Corrente</option>
          <option value="poupanca">Conta Poupança</option>
        </select>
      </div>
      <div class="grid-2-g grid-3-m grid-12-s label column" v-if="form.id_banco == 55">
        <label>Operação Conta</label>
        <select type="text" class="input" v-model="form.operacao_conta">
          <option value="null">Selecione</option>
          <option value="001">001 - Conta corrente de Pessoa Física</option>
          <option value="003">003 - Conta corrente de Pessoa Jurídica</option>
          <option value="013">013 - Poupança de pessoa Física</option>
          <option value="022">022 - Poupança de pessoa Jurídica</option>
        </select>
      </div>
      <div class="grid-1-g grid-3-m grid-12-s label column">
        <label>Titular da Conta</label>
        <select type="text" class="input" v-model="form.titular_conta" required>
          <option value>Selecione</option>
          <option value="pf">Pessoa Física</option>
          <option value="pj">Pessoa Jurídica</option>
        </select>
      </div>
    </div>

    <ContratoSupporter :id="form.id" />
    <EquipeSupporter :id="form.id" />

    <div v-if="form.nome_criado_por" class="info row wrap column-s justify-around">
      <div class="text-center grid-6 grid-12-s">
        <label>Criado por</label>
        <div>{{ form.nome_criado_por }} em {{ form.criado_em | date }}</div>
      </div>
      <div class="text-center grid-6 grid-12-s" v-if="form.nome_alterado_por">
        <label>Alterado por</label>
        <div>{{ form.nome_alterado_por }} em {{ form.alterado_em | date }}</div>
      </div>
    </div>

    <div class="controls row justify-center">
      <br /><br />
      <Button type="submit" :loader="loader" layout="green-go"><i class="fa fa-edit" />{{ form.update ? "ATUALIZAR" :
        "ADICIONAR" }}</Button>&nbsp;&nbsp;&nbsp;
      <Button v-if="form.update && form.status == 'ativo'" type="button" @click="del" :loader="loader"
        layout="red-go"><i class="fa fa-trash" /> DESATIVAR</Button>
      <Button v-if="form.update && form.status == 'inativo'" type="button" @click="updateStatus" :loader="loader"
        layout="green-go white"><i class="fa fa-check" /> ATIVAR</Button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button.vue";
import ContratoSupporter from "@/views/admin/components/ContratoSupporter.vue";
import EquipeSupporter from "@/views/admin/components/EquipeSupporter.vue";
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
  name: "SupporterForm",
  components: { Button, ContratoSupporter, EquipeSupporter },
  props: { form: Object },
  data() {
    return {
      loader: false,
    };
  },
  methods: {
    ...mapActions("user", ["GET_BANK", "PUT_BANK"]),
    ...mapActions("general", ["LOAD_BANK", "LOAD_CEP"]),
    cep() {
      if (this.form.cep.length > 9)
        this.LOAD_CEP(this.form.cep.replace(".", "").replace("-", "")).then((r) => {
          if (r.logradouro) {
            this.form.logradouro = r.logradouro;
            this.form.bairro = r.bairro;
            this.form.cidade = r.localidade;
            this.form.estado = r.uf;
          }
        });
    },
    async send() {
      this.loader = true;
      await this.form.send(this.form);
      this.loader = false;
    },
    async updateStatus() {
      this.loader = true;
      this.form.updateStatus(this.form.id)
      this.loader = false;
    },
    del() {
      if (confirm(`Deseja desativar o Supporter ${this.form.nome}?`)) {
        this.loader = true;
        this.form
          .del(this.form)
          .then(() => (this.loader = false))
          .catch(() => (this.loader = false));
      }
    },
  },
  beforeMount() {
    //this.GET_BANK().then(() => (this.loader = false));
    this.LOAD_BANK();
  },
  computed: {
    ...mapGetters("user", ["bank", "user"]),
    ...mapGetters("general", ["banks"]),
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.supporterForm
  @include form
  h3
    text-transform: uppercase
  select
    width: 93%
    max-width: 93%
</style>
